import CollaborationBox from "./collaboration-box";
import styles from '@v2/components/pages/shop/collab.styles';
import { imgV2 as img } from '@styles/utils';

export default function Collaborations({ category }: { category: any }) {
    return (
        <>
            {category.products && category.products.length
                ?
            <div className={`category ${category.id}`} id={`${category.id}`}>
                <div className="category-title mb-5">
                    <h2>{category.title}
                        {category.pricePerMeal &&
                            <span>${category.products[0].price.toFixed(2)} per box</span>
                        }
                    </h2>
                    <div>{category.description}</div>
                </div>
                <div className="products">
                    <div className="row">
                        {category.products
                            .map((product: any) =>
                                <div key={product.id} className="col-lg-6 col-md-6 col-12 mb-4">
                                    <CollaborationBox product={product} disabled={false}  />
                                </div>)}
                        <div className="col-lg-6 col-md-6 col-12 mb-4">
                            <div style={{ position: 'relative' }}>
                                <img className="w-100" src={img('collaboration/tdp.png')} alt="brain-box" />
                                <img className={styles.spriteOne} src={img('collaboration/sprite1.png')} alt="Sprite One" />
                                <div className={styles.containerDoughMain}>
                                    <img className={styles.headline} src={img('collaboration/headline.png')} alt="Cerebelly X The Dough Project" />
                                    <a href="http://cerebelly.com/landing/cerebelly-x-the-dough-project"
                                        target="_blank"
                                        rel="noreferrer"
                                        className={`button white w-100 ${styles.btnLearnMore}`}>
                                        Learn More
                                    </a>
                                </div>
                                <img className={styles.spriteTwo} src={img('collaboration/sprite2.png')} alt="Sprite Two" />
                            </div>
                        </div>
                    </div>
                </div>
            </div> : null}
        </>
    );
}